import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditCurrentPositionsResolverErrorStatesEnum {
    GetParentResolverDataFailed = ErrorStateScheduleEnum.PanelAccountsEditCurrentPositionsResolverErrorStatesStartIndex,
    GetCurrentPositionsFailed
}
